import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthProvider';
import { useNavigate } from 'react-router-dom';
import './Account.css';

const Account = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [userData, setUserData] = useState({ plan: 'free', interviewCount: 0 });

  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        const token = await user.getIdToken();
        const response = await fetch('/get-user-data', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.ok) {
          const data = await response.json();
          setUserData(data);
        } else {
          console.error("Failed to fetch user data:", response.statusText);
        }
      }
    };

    fetchUserData();
  }, [user]);

  const handleUpgrade = () => {
    navigate('/pricing');
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <div className="account-container">
      <h1>Welcome, {user.displayName}!</h1>
      <p>Current Plan: {userData.plan}</p>
      <p>Interviews Conducted: {userData.interviewCount}</p>
      {userData.plan === 'free' && (
        <button onClick={handleUpgrade}>Upgrade to Pro</button>
      )}
    </div>
  );
};

export default Account;